var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_37959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 18.6666H19.6134L19.2401 18.3066C20.8401 16.44 21.6668 13.8933 21.2134 11.1866C20.5868 7.47998 17.4934 4.51998 13.7601 4.06665C8.1201 3.37331 3.37344 8.11998 4.06677 13.76C4.5201 17.4933 7.4801 20.5866 11.1868 21.2133C13.8934 21.6666 16.4401 20.84 18.3068 19.24L18.6668 19.6133V20.6666L24.3334 26.3333C24.8801 26.88 25.7734 26.88 26.3201 26.3333C26.8668 25.7866 26.8668 24.8933 26.3201 24.3466L20.6668 18.6666ZM12.6668 18.6666C9.34677 18.6666 6.66677 15.9866 6.66677 12.6666C6.66677 9.34665 9.34677 6.66665 12.6668 6.66665C15.9868 6.66665 18.6668 9.34665 18.6668 12.6666C18.6668 15.9866 15.9868 18.6666 12.6668 18.6666Z",
    fill: "#2B8C34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_37959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/search-green.d92409849287d9bf882e3348eb8f2151.svg";
export { ForwardRef as ReactComponent };